import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErr } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("vv_admin_token");
        if (!token) { setLoading(false); return; }
        api.get("/auth/me")
            .then((r) => setAdmin(r.data))
            .catch(() => { localStorage.removeItem("vv_admin_token"); setAdmin(null); })
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("vv_admin_token", data.access_token);
            const me = await api.get("/auth/me");
            setAdmin(me.data);
            return { ok: true };
        } catch (e) {
            return { ok: false, error: formatApiErr(e.response?.data?.detail) || e.message };
        }
    };

    const logout = () => {
        localStorage.removeItem("vv_admin_token");
        setAdmin(null);
    };

    return (
        <AuthCtx.Provider value={{ admin, loading, login, logout }}>
            {children}
        </AuthCtx.Provider>
    );
};

export const useAuth = () => useContext(AuthCtx);
